import type { Craftsman } from '../types';

export type CraftsmanBadgeLevel = NonNullable<Craftsman['badgeLevel']>;

const OVERRIDE_LEVELS = new Set(['excellent', 'good', 'warning', 'risk']);

/** 依評分自動分級（與 DB calculate_badge_level 一致） */
export function calculateCraftsmanBadgeLevelFromRating(
  rating: number,
  totalReviews: number
): CraftsmanBadgeLevel {
  if (totalReviews === 0) return 'none';
  if (rating >= 4.8) return 'excellent';
  if (rating >= 4.0) return 'good';
  if (rating >= 3.0) return 'warning';
  if (rating > 2.0) return 'warning';
  return 'risk';
}

/** 管理員覆寫優先，否則自動 */
export function resolveCraftsmanBadgeLevel(
  rating: number,
  totalReviews: number,
  override: string | null | undefined
): CraftsmanBadgeLevel {
  if (override != null && OVERRIDE_LEVELS.has(override)) {
    return override as CraftsmanBadgeLevel;
  }
  return calculateCraftsmanBadgeLevelFromRating(rating, totalReviews);
}

/**
 * 列表／RPC 列：有合法覆寫用覆寫；否則若已有 badge_level（如 get_nearby 已算 effective）則沿用；否則本地計算。
 */
export function resolveCraftsmanBadgeLevelForRow(row: {
  rating?: number | null;
  total_reviews?: number | null;
  badge_level?: string | null;
  badgeLevel?: string | null;
  badge_level_override?: string | null;
}): CraftsmanBadgeLevel {
  const ov = row.badge_level_override;
  if (ov != null && OVERRIDE_LEVELS.has(ov)) {
    return ov as CraftsmanBadgeLevel;
  }
  const pre = row.badge_level || row.badgeLevel;
  if (
    pre === 'none' ||
    pre === 'excellent' ||
    pre === 'good' ||
    pre === 'warning' ||
    pre === 'risk'
  ) {
    return pre;
  }
  return calculateCraftsmanBadgeLevelFromRating(row.rating ?? 0, row.total_reviews ?? 0);
}
